import { PublisherInterface } from '@chili-publish/publisher-interface'

import Tools from 'shared/components/Tools'
import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import Text from 'shared/ui/Text'
import StartDesigningPanel from 'shared/components/Tools/components/LeftPanel/components/StartDesigningPanel'

type HeaderProps = {
  onLeaveClick: () => void
  isSaveLoading: boolean
  isDocumentLoaded: boolean
  publisherConnector: PublisherInterface | null
  switchEditor: () => void
}

const AdminProjectsEditorHeader: React.FC<HeaderProps> = ({
  onLeaveClick,
  isSaveLoading,
  isDocumentLoaded,
  publisherConnector,
  switchEditor
}) => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex width={500} columnGap={16} alignItems="center">
        <Button
          loading={isSaveLoading}
          textId="Editor.leaveButton"
          intent="primary-brand-02"
          onPress={onLeaveClick}
          icon="left"
          iconName="save"
          minWidth={162}
        />
        <Text tag="h1" text="Edit page" size={24} weight={600} />
      </Flex>

      <Tools
        publisherConnector={publisherConnector!}
        isDocumentLoaded={isDocumentLoaded}
        showLeftPanel={false}
        showRightPanel={false}
        renderDefaultLeftPanel={() => <StartDesigningPanel />}
      />

      <Flex width={500} columnGap={8} justifyContent="flex-end">
        <Button
          textId="AdminEditor.switchEditor"
          intent="secondary-contrast"
          size="md"
          maxHeight={34}
          onPress={switchEditor}
        />
      </Flex>
    </Flex>
  )
}

export default AdminProjectsEditorHeader
